import fr from './fr';
import de from './de';
import en from './en';

export default {
    fr : fr,
    en : en,
    de : de
}